export default __webpack_public_path__ + "static/arrow_03_dark-7a3f01d68b39352eecf01f4481781a96.png";